import { useUrlState, _resetAllDefaultsCachesForTesting } from './useUrlState'

export interface PursuitFilters {
  since: Date
  until: Date
  page: number
  page_size: number
  min_appearances: number
}

const DAY_MS = 24 * 60 * 60 * 1000

function parseDateOrDefault(raw: unknown, fallback: Date): Date {
  if (raw instanceof Date) return raw
  if (typeof raw !== 'string') return fallback
  const d = new Date(raw)
  return isNaN(d.getTime()) ? fallback : d
}

function parseIntOrDefault(raw: unknown, fallback: number): number {
  if (typeof raw !== 'string') return fallback
  const n = parseInt(raw, 10)
  return Number.isNaN(n) ? fallback : n
}

export function _resetDefaultsCache(): void {
  _resetAllDefaultsCachesForTesting()
}

export function usePursuitFiltersUrl() {
  const { state, update } = useUrlState<PursuitFilters>({
    cacheKey: 'pursuit-filters',
    volatileDefaults: true,
    defaults: () => ({
      since: new Date(Date.now() - DAY_MS),
      until: new Date(),
    }),
    parse: (q) => ({
      since: parseDateOrDefault(q.since, new Date(Date.now() - DAY_MS)),
      until: parseDateOrDefault(q.until, new Date()),
      page: parseIntOrDefault(q.page, 1),
      page_size: parseIntOrDefault(q.page_size, 25),
      min_appearances: parseIntOrDefault(q.min, 1),
    }),
    serialize: (patch, current) => {
      const out = { ...current }
      if (patch.since) out.since = patch.since.toISOString()
      if (patch.until) out.until = patch.until.toISOString()
      if (patch.page !== undefined) out.page = String(patch.page)
      if (patch.page_size !== undefined) out.page_size = String(patch.page_size)
      if (patch.min_appearances !== undefined) out.min = String(patch.min_appearances)
      return out
    },
  })
  return { filters: state, update }
}
